function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'bianco': 'rgb(255, 255, 255)','nero': 'rgb(0, 0, 0)','giallo': 'rgb(255, 240, 0)','blu': 'rgb(0, 51, 153)','fuxia': 'rgb(244, 0, 161)','rosso': 'rgb(255, 0, 0)','verde': 'rgb(34, 139, 34)','celeste': 'rgb(0, 127, 255)','corallo': 'rgb(237, 116, 101)','nera': 'rgb(0, 0, 0)','bianca': 'rgb(255, 255, 255)','fucsia': 'rgb(244, 0, 161)','bordeaux': 'rgb(95, 2, 31)','nero-opaco': 'rgb(0, 0, 0)',};

    this.images = {'argento': 'url("//style4us.shop/cdn/shop/files/argento_scheda_colori_120x.png?v=10863223848299688166")','oro': 'url("//style4us.shop/cdn/shop/files/oro_scheda_colori_120x.png?v=4592270329789301029")','rosa-glitter': 'url("//style4us.shop/cdn/shop/files/glitter_scheda_colori_120x.png?v=13713519181101815292")','glitter': 'url("//style4us.shop/cdn/shop/files/glitter_scheda_colori_120x.png?v=13713519181101815292")','rosa-glitterato': 'url("//style4us.shop/cdn/shop/files/glitter_scheda_colori_120x.png?v=13713519181101815292")','nero-lucido': 'url("//style4us.shop/cdn/shop/files/NERO_LUCIDO_120x.png?v=12550043897259020993")',};

    this.triggers = ['color','colour','couleur','farbe','cor','colore','colore lavorazione','colore grembiule',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
